"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isEmailValid = function isEmailValid(value) {
  var whitelistedDomains = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var regex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@\w+([.-]?\w+)*(\.\w+)+$/);

  if (!regex.test(value)) {
    return false;
  }

  if (whitelistedDomains.length === 0) {
    return true;
  }

  var domain = value.split('@')[1];
  return whitelistedDomains.includes(domain);
};

var _default = isEmailValid;
exports["default"] = _default;
//# sourceMappingURL=isEmailValid.js.map